import { useTranslation } from '@crew/modules/i18n'
import { Modal } from 'components/layouts/modal/modal'
import { FC, memo } from 'react'
import { GroupChatEditForm } from './components/GroupChatEditForm/groupChatEditForm'

export type GroupChatEditDialogProp = {
  projectId: string
  isOpen: boolean
  onSubmit: (projectId: string) => void
  onDeleted?: () => void
  onClose: () => void
}

export const GroupChatEditDialog: FC<GroupChatEditDialogProp> = memo(
  (props) => {
    const { t } = useTranslation()

    return (
      <Modal
        id="group-chat-edit-dialog"
        className="flex flex-col lg:min-w-[40vw]"
        title={t('label.groupChatEdit')}
        isOpen={props.isOpen}
        onClose={props.onClose}
      >
        <GroupChatEditForm
          projectId={props.projectId}
          onSubmit={props.onSubmit}
          onDeleted={props.onDeleted}
          onCancel={props.onClose}
        />
      </Modal>
    )
  }
)
